/*
 * @Author: linghujie 391103334@qq.com
 * @Date: 2022-10-19 08:43:23
 * @LastEditors: linghujie 391103334@qq.com
 * @LastEditTime: 2023-03-10 09:52:43
 * @FilePath: \shared-mask-machine-website\src\api\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
console.log(process)
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers['category'] = '2'
// 1.创建axios的实例
const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API ,
    timeout: 10000,
})

// 2.axios的拦截器
// 2.1.请求拦截的作用
request.interceptors.request.use(config => {
    return config
}, err => {
    // console.log(err);
})

// 2.2.响应拦截
request.interceptors.response.use(res => {
    return res.data
}, err => {
    console.log(err);
})
export default request


// WEBPACK FOOTER //
// ./src/api/index.js